module.exports = __webpack_public_path__ + "static/media/FasadNorr.4a92ee77.JPG";